import React, { useEffect } from 'react';
import { getUsername } from '../../app/AuthService';

const RadioRedirect: React.FC = () => {
  useEffect(() => {
    const handleRadioRedirect = async () => {
      try {
        // Get token
        const tokenResponse = await fetch(
          'https://ws-portailsig.axione.fr/ArcGisTokenManager/rest/token'
        );
        const tokenData = await tokenResponse.json();
        const token = tokenData.token;

        const username = getUsername();

        const appliURL = 'https://ws-portailsig.axione.fr/axionejs';
        const configName = 'e-radio/profil_eradio';
        const appConfig = 'config_eradio.json';

        const redirectURL = `${appliURL}/?profile=${configName}&config=${appConfig}&token=${token}&user=${username}`;

        window.location.href = redirectURL;
      } catch (error) {
        console.error('Error during radio redirect:', error);
      }
    };

    handleRadioRedirect();
  }, []);

  return <div>Redirecting to Radio service...</div>;
};

export default RadioRedirect;
